import { Theme } from '@mui/material/styles';

// Styles object containing className-based styles
export const scoreSummaryStyles = {
  scoreContainer: {
    borderRadius: '12px',
  },
  scoreRow: (theme: Theme, level: number) => ({
    padding: theme.spacing(2, 3),
    backgroundColor: 'white !important',
    marginLeft: level * 3,
    marginBottom: '5px',
    borderBottom: '1px solid #E0E0E0 !important',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateX(2px)',
    },
  }),
  scoreLabel: (level: number) => ({
    fontWeight: level === 0 ? 600 : 500,
    fontSize: level === 0 ? '16px' : '14px',
    color: level === 0 ? '#1A1A1A' : '#333333',
    letterSpacing: '0.15px',
    lineHeight: 1.4,
  }),
  percentageChip: (theme: Theme, level: number, percentage: number) => ({
    ...getPercentageColors(percentage),
    fontWeight: 600,
    fontSize: level === 0 ? '14px' : '13px',
    height: level === 0 ? '28px' : '24px',
    borderRadius: '14px',
    minWidth: '60px',
    '& .MuiChip-label': {
      padding: theme.spacing(0, 1.5),
    },
  }),
  pointsText: (level: number) => ({
    fontSize: level === 0 ? '14px' : '13px',
    color: '#757575',
    fontWeight: 400,
  }),
  overallScoreChip: {
    background: 'linear-gradient(45deg, #667eea 30%, #764ba2 90%)',
    color: 'white',
    fontWeight: 700,
    fontSize: '13px',
    borderRadius: '16px',
    boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
  },
  contentContainer: {
    background: 'linear-gradient(135deg, #FAFAFA 0%, #F5F5F5 100%)',
    minHeight: '100px',
  },
  emptyState: (theme: Theme) => ({
    padding: theme.spacing(4),
    textAlign: 'center',
    color: '#757575',
  }),
  divider: {
    borderTop: '1px solid #E0E0E0',
    opacity: 0.6,
  },
};

// Helper function to get percentage-based colors
export const getPercentageColors = (percentage: number) => {
  if (percentage >= 90) return { backgroundColor: '#E8F5E8', color: '#2E7D32' };
  if (percentage >= 70) return { backgroundColor: '#FFF3E0', color: '#F57C00' };
  if (percentage >= 50) return { backgroundColor: '#FFF8E1', color: '#F9A825' };
  return { backgroundColor: '#FFEBEE', color: '#C62828' };
};

// CSS class names for conditional styling
export const scoreClassNames = {
  scoreContainer: 'score-container',
  scoreRow: 'score-row',
  scoreLabel: 'score-label',
  percentageChip: 'percentage-chip',
  pointsText: 'points-text',
  overallScoreChip: 'overall-score-chip',
  contentContainer: 'content-container',
  emptyState: 'empty-state',
  divider: 'divider',
};
